module.exports = __webpack_public_path__ + "media/images/sp/page_common/noimage/square/model_black-ed2576f83ef6691f52fdb7e2a78d723e.jpg";